import { ApiClient } from '../../../utils/apiClient';
import { handleApiResult } from '../../../utils/apiErrorHandler';

interface CalDavConnectResponse {
  principal_url: string;
  calendars: Array<{ name: string; url: string }>;
}

export interface CalDavConnectParams {
  calendar_id: string;
  email: string;
  password: string;
  start: string;
  caldav_base_url?: string;
  calendar_url?: string;
}

export const caldavService = {
  connect: async (params: CalDavConnectParams): Promise<CalDavConnectResponse> => {
    const requestParams = {
      calendar_id: params.calendar_id,
      email: params.email,
      password: params.password,
      start: params.start,
      ...(params.caldav_base_url && { caldav_base_url: params.caldav_base_url }),
      ...(params.calendar_url && { calendar_url: params.calendar_url }),
    };

    const response = await ApiClient.post('/calendars/caldav/connect/', requestParams);
    const result = await handleApiResult<CalDavConnectResponse>(
      response,
      'Failed to connect CalDAV'
    );
    if (!result.success || !result.data) {
      throw new Error(result.errors?.generalError || 'Failed to connect CalDAV');
    }
    return result.data;
  },

  confirm: async (params: {
    calendar_id: string;
    calendar_url: string;
  }): Promise<{ message: string }> => {
    const response = await ApiClient.post('/calendars/caldav/confirm/', params);
    const result = await handleApiResult<{ message: string }>(response, 'Failed to confirm CalDAV');
    if (!result.success || !result.data) {
      throw new Error(result.errors?.generalError || 'Failed to confirm CalDAV');
    }
    return result.data;
  },

  disconnect: async (calendar_id: string): Promise<{ message: string }> => {
    const response = await ApiClient.post('/calendars/caldav/disconnect/', { calendar_id });
    const result = await handleApiResult<{ message: string }>(
      response,
      'Failed to disconnect CalDAV'
    );
    if (!result.success || !result.data) {
      throw new Error(result.errors?.generalError || 'Failed to disconnect CalDAV');
    }
    return result.data;
  },
};
